<div style="
    background-image: url('../../../../assets/imagesNew/Proceed2.png') !important;
    background-size: cover;
    height: 100vh;
  ">
    <span style="color: white; float: right; margin: 4% 7%; position: relative;" *ngIf="(version)"> <h6>V{{version}}</h6> </span>


   
    <p-dialog [(visible)]="displaypopup"
              [draggable]="false"
              [modal]="true"
              positionType="absolute"
              [closable]="false"
              [maximizable]="false"
              [style]="{ width: '30vw' }">
        <p-header>
            <h2 class="mb-0"
                style="
          font-weight: unset !important;
          font-size: larger !important;
          text-align: center !important;
        ">
                {{ title }}
            </h2>
        </p-header>



       


        <div class="grid">
            <form [formGroup]="questionForm"
                  (ngSubmit)="onSubmitForm()"
                  class="col-11 col-md-11 col-lg-11">
                <ng-container formArrayName="questionFormArray">
                    <div *ngFor="
              let questionControl of getFormAsArray().controls;
              let i = index
            "
                         class="mb-3">
                        <ng-container [formGroupName]="i">
                            <div class="grid mt-0">
                                <!--<div class="field col-12 md:col-1">

                        </div>-->
                                <div class="field col-12 md:col-12 mb-0">
                                    <span>
                                        <p-checkbox name="groupname"
                                                    [binary]="true"
                                                    formControlName="isSelected"></p-checkbox>
                                    </span>
                                    <span>
                                        <label style="padding-left: 10px; margin-bottom: 0px !important">
                                            {{ questionControl.get('questionDesciption').value }}
                                        </label>
                                    </span>
                                </div>
                            </div>
                            <div class="grid mt-0"
                                 *ngIf="
                  questionForm
                    .get('questionFormArray')
                    .controls[i].get('isSelected').value
                ">
                                <div class="field col-12 md:col-1 mb-1"></div>
                                <div class="field p-fluid col-11 md:col-11 mb-1">
                                    <span class="p-float-label">
                                        <input id="float-input1"
                                               type="text"
                                               pInputText
                                               formControlName="answer" />
                                        <label for="float-input1"> Answer here</label>
                                    </span>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
                <div class="grid mt-5">
                    <div class="field col-12 md:col-12 mb-0 ml-6"
                         style="text-align: center">
                        <button pButton
                                type="submit"
                                label="Verify"
                                class="p-button-plain"
                                style="width: 10rem"></button>
                    </div>
                </div>
            </form>


            <div *ngIf="statusErroDisplay_403" class="custom-error col-12 md:col-12 d-flex justify-content-center align-items-center">
                Security questions and answers don't match!
            </div>

            <div *ngIf="statusErroDisplay_404" class="custom-error col-12 md:col-12 d-flex justify-content-center align-items-center">
                Specified user does not exist!
            </div>

        </div>
    </p-dialog>
    <div *ngIf="!displaypopup"
         style="
      height: 100%;
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    ">
        <div style="
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
      ">
            <div style="
          background-color: #f8d7da;
          color: #721c24;
          padding: 20px;
          border: 1px solid #f5c6cb;
          border-radius: 5px;
          text-align: center;
          box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        ">
                You have not set up your security questions yet. Please contact the
                administrator to reset your password.
            </div>
        </div>
    </div>
</div>
